import React, { useState } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import ThemeConsumer from "shared/components/ThemeConsumer"
import Typograph from "../../Typograph"
import Loading from "components/Loading/LoadingOpacity"

import { useTimeout } from "hooks/useTimeout"

const Toast = ({
  id,
  theme,
  icons,
  type = "sucess",
  acceptHtml = false,
  message = "",
  delay,
  onClose,
  onExit
}) => {
  const [open, setOpen] = useState(true)
  if (delay !== 0) {
    useTimeout(
      () => {
        setOpen(false)
        onClose()
        onExit()
      },
      delay,
      [onClose, onExit],
      window.scrollTo({ top: 0, behavior: "smooth" })
    )
  }

  const sucess = type === "sucess"

  const IconInfo = icons.Info
  const containerClasses = classnames(theme.container, theme.pv3, theme.ph3, {
    [theme.borderSucess]: sucess,
    [theme.borderError]: !sucess
  })
  const buttonClasses = classnames(
    "u-flex u-flexAlignItemsCenter u-flexJustifyCenter",
    theme.button,
    {
      [theme.sucessBackground]: sucess,
      [theme.errorBackground]: !sucess
    }
  )
  const strokeLeftClasses = classnames(theme.stroke, theme.strokeLeft)
  const strokeRightClasses = classnames(theme.stroke, theme.strokeRight)

  const iconClasses = classnames(theme.icon, {
    [theme.errorIcon]: !sucess
  })

  const descriptionClasses = classnames("u-block", theme.mt3)

  const propsDescription = {
    htmlTag: "p",
    size: "small",
    color: "outer_space",
    weight: "medium",
    classNames: descriptionClasses
  }

  return (
    <article id={id} className={containerClasses}>
      <header className="u-flex u-flexJustifyBetween">
        <Typograph
          htmlTag="h4"
          size="small"
          weight="semi_bold"
          color="outer_space"
          classNames="u-flex u-flexAlignItemsCenter"
        >
          <IconInfo className={iconClasses} />
          Informação!
        </Typograph>
        <button
          className={buttonClasses}
          onClick={() => {
            setOpen(false)
            onClose()
          }}
        >
          <div className={theme.containerStroke}>
            <hr className={strokeLeftClasses} />
            <hr className={strokeRightClasses} />
          </div>
        </button>
      </header>
      {acceptHtml && (
        <Typograph
          {...propsDescription}
          dangerouslySetInnerHTML={{ __html: message }}
        />
      )}

      {!acceptHtml && <Typograph {...propsDescription}>{message}</Typograph>}
      <Loading isOpen={open} />
    </article>
  )
}

Toast.propTypes = {
  id: PropTypes.string,
  theme: PropTypes.shape({
    container: PropTypes.string,
    pv3: PropTypes.string,
    ph3: PropTypes.string,
    button: PropTypes.string,
    sucessBackground: PropTypes.string,
    errorBackground: PropTypes.string,
    stroke: PropTypes.string,
    strokeLeft: PropTypes.string,
    strokeRight: PropTypes.string,
    containerStroke: PropTypes.string,
    icon: PropTypes.string,
    errorIcon: PropTypes.string,
    mt3: PropTypes.string,
    borderSucess: PropTypes.string,
    borderError: PropTypes.string
  }),
  icons: PropTypes.shape({
    Info: PropTypes.func
  }),
  type: PropTypes.string,
  acceptHtml: PropTypes.bool,
  message: PropTypes.string,
  delay: PropTypes.number,
  onExit: PropTypes.func,
  onClose: PropTypes.func
}

export default ThemeConsumer("UIToast")(Toast)



// WEBPACK FOOTER //
// ./src/components/Toast/v2/index.js